import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  button: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px 20px',
    fontSize: 15,
    fontFamily: 'NeoSansStd',
    lineHeight: 1,
    background: theme.custom.accept,
    borderRadius: 29,
    color: '#fff',
    textDecoration: 'none',
    textTransform: 'capitalize',
  },
  description: {
    margin: 0,
    marginBottom: 15,
    fontSize: 17,
    color: '#30344B',
  },
}));
